import React from 'react';
import {isFromAccountingTeam, isFromTechTeam} from '../../auth/UserPermissions';
import Box from '@amzn/awsui-components-react/polaris/box';
import PermissionsModal from '../PermissionsModal';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import * as paths from '../../util/paths';
import {BreadcrumbGroup} from '@amzn/awsui-components-react';
import {MY_TEST_ITEM_2, TestRequest} from './model/TestRequest';
import Header from '@amzn/awsui-components-react/polaris/header';
import Button from '@amzn/awsui-components-react/polaris/button';
import Container from '@amzn/awsui-components-react/polaris/container';
import ContentLayout from '@amzn/awsui-components-react/polaris/content-layout';
import AddTestCaseTypeDropDown from './components/AddTestCaseTypeDropDown';
import TestCaseFunctionalityDropDown from './components/TestCaseFunctionalityDropDown';

export default function AddTestCasesForTestRequest(props) {
    const [hasAccess] = React.useState(isFromTechTeam() || isFromAccountingTeam());
    const [testCaseType, setTestCaseType] = React.useState();
    const [testFeatureType, setTestFeatureType] = React.useState();

    const getRequestName = () => {
        let request: TestRequest | undefined;

        if (props.request) {
            request = props.request;
        }
        else if (props.history.location.state) {
            request = props.history.location.state.request;
        }
        else {
            const requestIdFromUrl = props.match.params.request_id;

            // FIXME - DB call here
            console.log("Simulating fetching from DB: " + requestIdFromUrl);
            request = MY_TEST_ITEM_2;
        }

        if (request) {
            return "Request - " + request.userLogin + " | " + request.testPurpose;
        }

        return "TODO";
    }

    // FIXME
    const getRequestId = () => {
        return MY_TEST_ITEM_2.identifier;
    }

    return (
        <Box>
            {!hasAccess && <PermissionsModal hasPageAccess={hasAccess}/>}
            {hasAccess && <SpaceBetween direction='vertical' size='xl'>
                <BreadcrumbGroup
                    items={[
                        { text: "Testing Home", href: paths.getRelativePath(paths.MANUAL_TESTING) },
                        { text: "Requests", href: paths.getRelativePath(paths.MANUAL_TESTING_USER_REQUESTS) },
                        { text: getRequestName(), href: paths.getRelativePath(paths.MANUAL_TESTING_VIEW_CURRENT_REQUEST).replace(':request_id', getRequestId()) },
                        { text: "Add Test Cases", href: paths.getRelativePath(paths.MANUAL_TESTING_ADD_TEST_CASES_TO_REQUEST) },
                    ]}
                    ariaLabel="Breadcrumbs"
                />
                <ContentLayout
                    header={
                        <SpaceBetween size="m">
                            <Header
                                variant="h1"
                                description="A Test Case is a set of one or more financial events that can be processed
                                to review the system outcome"
                            >
                                Add New Test Cases
                            </Header>
                        </SpaceBetween>
                    }
                >
                    <SpaceBetween size='l' direction='vertical'>
                        <Container
                            header={
                                <Header
                                    variant="h2"
                                >
                                    Choose Type
                                </Header>
                            }
                        >
                            <SpaceBetween size='l' direction='vertical' >
                                <Box key='test-case-type-dropdown'>
                                    <AddTestCaseTypeDropDown setTestCaseType={setTestCaseType}/>
                                </Box>
                                {testCaseType && <Box key='test-feature-type-dropdown'>
                                     <TestCaseFunctionalityDropDown setFeatureType={setTestFeatureType} />
                                </Box> }
                            </SpaceBetween>
                        </Container>
                        {testCaseType && testFeatureType && <Container
                            header={
                                <Header
                                    variant="h2"
                                >
                                    Generate Cases
                                </Header>
                            }
                        >
                            <SpaceBetween size='xs' direction='horizontal' >
                                <Button
                                    key='add-test-cases-button'
                                >
                                    Use Pre-Configured Test Cases
                                </Button>
                                <Button disabled={true}>
                                    Create Custom Test Cases
                                </Button>
                            </SpaceBetween>
                        </Container>}
                    </SpaceBetween>
                </ContentLayout>
            </SpaceBetween>}
        </Box>
    );
}